<template>
  <app-layout swipe @swipeRight="swipeRight" @swipeLeft="swipeLeft">
    <template slot="top">
      <div class="brow align-items-center grey lighten-2 brown--text text--darken-2">
        <div class="col-3 lft">
          <v-btn color="brown darken-3" v-if="prev" :to="{name: 'workoutShow', params: {id: prev.id}}" class="tight amber--text">
            <i class="icon-arrow-left2"/>
          </v-btn>
        </div>
        <div class="col-6 noWrap">
          <div class="workout_navTitle">
            <strong class="louds">{{ plan.attributes.name }}</strong>
          <br>
          <small>
            <span>{{ plan.relationships.plan_trainings.data.length }} Übungen</span>
            <span v-if="plan.attributes['level_' + currentUser.level + '_sets']">
               &middot; {{ plan.attributes['level_' + currentUser.level + '_sets'] }} Sets
            </span>
            <span v-if="plan.attributes['level_' + currentUser.level + '_reps']">
               &middot; {{ plan.attributes['level_' + currentUser.level + '_reps'] }} Reps
            </span> 
          </small>
          <v-btn small icon flat color="brown darken-2" class="ma-0" @click="showMore = !showMore">
              <i class="icon-info"/>
            </v-btn>
          </div>
          
        </div>
        <div class="col-3 rgt">
          <v-btn color="brown darken-3" v-if="next" :to="{name: 'workoutShow', params: {id: next.id}}" class="tight amber--text">
            <i class="icon-arrow-right2"/>
          </v-btn>
        </div>
      </div>

      <div class="section bright flat brown--text text--darken-4">
        <div class="corset full">
          <div class="moreInfo" v-if="showMore">
            <img :src="plan.attributes.image_url" class="responsive wrktPic" :key="'TrnPlnPic-' + plan.id" v-if="plan.attributes.image_url" />
            <img src="../../assets/images/blank_bg.png" class="responsive wrktPic" v-else />
            <table class="table table-sm lft no-press table-no-head" v-if="3 === 4">
              <tbody>
                <tr v-for="nmbr in 3">
                  <td>
                    <span>Level {{ nmbr }}: &nbsp;</span>
                  </td>
                  <td>
                    <span :class="{bold: String(nmbr) === String(currentUser.level)}" v-if="plan.attributes['level_' + nmbr + '_reps']">
                      {{ plan.attributes['level_' + nmbr + '_reps'] }} Reps
                    </span>
                    <span v-else>&nbsp; &nbsp; &nbsp;</span>
                  </td>
                  <td class="rgt">
                    <span :class="{bold: String(nmbr) === String(currentUser.level)}" v-if="plan.attributes['level_' + nmbr + '_sets']">
                      {{ plan.attributes['level_' + nmbr + '_sets'] }} Sets
                    </span>
                    <span v-else>&nbsp; &nbsp; &nbsp;</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          
        </div>
      </div>
    </template>

    


    <div class="brow justify-content-center">
      <training-tile    v-for="t in plan.relationships.plan_trainings.data" 
                        :planTraining="getTraining(t)" 
                        :plan="plan"/>
    </div>
    <template slot="footer">
        <v-btn to="/workout" v-html="activeWorkout.plan.name" color="amber" large class="width" v-if="!!activeWorkout" />
        <v-btn @click="startWorkout" color="success" large class="width" v-else>
          {{plan.attributes.name}} <v-icon v-html="'arrow_right'" /> starten
        </v-btn>
    </template>
  </app-layout>
</template>

<script>
import FullBox          from '@/components/ui/FullBox.vue';
import axios            from '@/services/axios';
import UiSpinner        from '@/components/ui/Spinner';
import trainingTile     from '@/views/workouts/trainingTile';
import { mapGetters }   from 'vuex';

  export default {
    data() {
      return {
        showMore: false
      }
    },
    computed: {
      ...mapGetters(["currentUser", "activeWorkout"]),
      plan() {
        let result = {}
        this.$store.state.trainingsPlans.forEach((plan) => {
          if ( this.$route.params.id === plan.id ) {
            result = plan
          }
        })
        return result
      },
      prev() {
        let index = this.$store.state.trainingsPlans.indexOf( this.plan )
        if (index > 0) {
          return this.$store.state.trainingsPlans[ index - 1 ]
        }
        return false
      },
      next() {
        let index = this.$store.state.trainingsPlans.indexOf( this.plan )
        if ((index + 1) < this.$store.state.trainingsPlans.length) {
          return this.$store.state.trainingsPlans[ index + 1 ]
        }
        return false
      }
    },
    methods: {
      swipeRight() {
        if (this.prev) {
          this.$router.push({name: 'workoutShow', params: {id: this.prev.id}})
        }
      },
      swipeLeft() {
        if (this.next) {
          this.$router.push({name: 'workoutShow', params: {id: this.next.id}})
        }
      },
      getTraining(that) {
        return this.$store.getters.getTraining(that)
      },
      startWorkout() {
        console.log("startWorkout", this.plan)
        
        let wrkt = {
          user_id:            this.currentUser.id,
          trainings_plan_id:  this.plan.id,
          starts_at:          new Date(),
          finished_at:        null,
          done:               false,
          level:              this.currentUser.level,
          sets:               this.plan.attributes['level_' + (this.currentUser.level || 1) + '_sets'],
          currentSet:         1,
          currentTraining:    1,
          plan: {
            id:             this.plan.id,
            name:           this.plan.attributes.name,
            copyright:      this.plan.attributes.copyright,
            
            excercise_rest: this.plan.attributes.excercise_rest,
            set_rest:       this.plan.attributes.set_rest,
            
            image_url:      this.plan.attributes.image_url,
            
            // level_reps:     this.plan.attributes['level_' + (this.currentUser.level || 1) + '_reps'],
            // level_sets:     this.plan.attributes['level_' + (this.currentUser.level || 1) + '_sets'],
            // each_reps:      this.plan.attributes.each_reps,
            // each_time:      this.plan.attributes.each_time,
            
            reps_type:      this.plan.attributes.reps_type
          },
          trainings:    [],
          excercises:   []
        }
        if (this.plan.relationships && this.plan.relationships.plan_trainings && this.plan.relationships.plan_trainings.data ) {
          for (let i = 0; i < this.plan.relationships.plan_trainings.data.length; i++) { 
            let planTraining = this.getTraining( this.plan.relationships.plan_trainings.data[i] )
            let training = this.getTraining( planTraining.relationships.training.data )
            console.log("planTraining", planTraining, "planTraining", training)
            let trng = {
              plan_training_id: planTraining.id,
              position:         planTraining.attributes.position,
              training_id:      training.id,
              name:             training.attributes.name,
              description:      training.attributes.description,
              // do_reps:          planTraining.attributes.do_reps,
              // do_time:          planTraining.attributes.do_time,
              image_url:        training.attributes.image_url
            }
            if ( planTraining.attributes.do_time ) { 
              trng['time'] = planTraining.attributes.do_time
            } else if ( planTraining.attributes.do_reps ) { 
              trng['reps'] = planTraining.attributes.do_reps
            } else if ( this.plan.attributes.each_time ) {
              trng['time'] = this.plan.attributes.each_time
            } else if ( this.plan.attributes.each_reps ) {
              trng['reps'] = this.plan.attributes.each_reps
            } else if ( this.plan.attributes['level_' + this.currentUser.level + '_reps'] ) {
              trng['reps'] = this.plan.attributes['level_' + this.currentUser.level + '_reps']
            }
            wrkt.trainings.push(trng)
          }
        }
        
        console.log("startedWorkout", wrkt)
        
        // 
        // this.$store.setters.startWorkout(wrkt)
        
        this.$store.dispatch('setActiveWorkout', wrkt )
        this.$router.push("/workout")
        
        
      }
    },
    components: {
      FullBox,
      UiSpinner,
      trainingTile
    }
    
  }
</script>

<style lang="scss">
.moreInfo {
  display: block; position: relative;

  img.wrktPic {
    width: 80%;
    max-width: 500px;
    margin: 0;
    vertical-align: top;
  }
}
.workout_navTitle {
  padding: 7px 0 1px;
  line-height: 1.1;
}
</style>